import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-import-documents',
  templateUrl: './import-documents.component.html',
  styleUrls: ['./import-documents.component.scss']
})
export class ImportDocumentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
